import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserProfile, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import comercial from './routes/comercial'
import rrhh from './routes/rrhh'
import seguridad from './routes/seguridad'
import catalogo from './routes/catalogo'
import inventario from './routes/inventario'
import vigilancia from './routes/vigilancia'
import logistica from './routes/logistica'
import cajas from './routes/cajas'
import cobranza from './routes/cobranza'
import reporte from './routes/reporte'
import portal from './routes/portal'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'rt-home',
      meta: {
        resource: 'rt-home',
      },
    },
    ...apps,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    ...comercial,
    ...rrhh,
    ...seguridad,
    ...catalogo,
    ...inventario,
    ...vigilancia,
    ...logistica,
    ...cobranza,
    ...cajas,
    ...reporte,
    ...portal,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  // Redirect if logged in
  const userProfile = getUserProfile()
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next(getHomeRouteForLoggedInUser(userProfile))
  }

  if (to.path === '/') {
    next(getHomeRouteForLoggedInUser(userProfile))
  }

  return next()
})

export default router
